<!-- Lessor -->
<div
  *ngIf="policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption"
  class="pt-12">
  <span class="font-app-bold text-darkest text-sm md:text-base">
    {{ "lessorInformations.title" | translate }}
  </span>
</div>
<!-- Lessor Type -->
<div
  *ngIf="
    getIsVisible(policyFieldsVM, PolicyFields.OPTIONALSERVICE, OptionalService.LessorType) &&
    policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption &&
    this.lessorDataCopy !== null
  "
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2 sm:pl-4 py-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "lessorInformations.lessorType" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="lessorTypeOptions"
        [(ngModel)]="lessorDataCopy.lessorType"
        appendTo="body"
        [disabled]="
          !getIsEditable(
            policyFieldsVM,
            PolicyFields.OPTIONALSERVICE,
            OptionalService.LessorType,
            hasEndorsementWait4Sign
          )
        "
        [styleClass]="
          getDropdownClass(
            lessorTypeHasChanged,
            getIsEditable(
              policyFieldsVM,
              PolicyFields.OPTIONALSERVICE,
              OptionalService.LessorType,
              hasEndorsementWait4Sign
            )
          ) + ' w-full'
        "
        (ngModelChange)="onLessorTypeChange()"></p-dropdown>
    </div>
  </div>
</div>
<!-- Lessor Name Selection-->
<div
  *ngIf="
    getIsVisible(policyFieldsVM, PolicyFields.OPTIONALSERVICE, OptionalService.LessorName) &&
    policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption &&
    this.lessorDataCopy !== null &&
    lessorSocialSelected
  "
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2 sm:pl-4 py-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "lessorInformations.lessorName" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="lessorOptions"
        [(ngModel)]="lessorDataCopy.name"
        appendTo="body"
        [disabled]="
          !getIsEditable(
            policyFieldsVM,
            PolicyFields.OPTIONALSERVICE,
            OptionalService.LessorName,
            hasEndorsementWait4Sign
          )
        "
        [styleClass]="
          getDropdownClass(
            lessorNameHasChanged,
            getIsEditable(
              policyFieldsVM,
              PolicyFields.OPTIONALSERVICE,
              OptionalService.LessorName,
              hasEndorsementWait4Sign
            )
          ) + ' w-full'
        "
        (ngModelChange)="onLessorNameChange()"></p-dropdown>
    </div>
  </div>
</div>
<!-- Lessor Name -->
<div
  *ngIf="
    getIsVisible(policyFieldsVM, PolicyFields.OPTIONALSERVICE, OptionalService.LessorName) &&
    policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption &&
    this.lessorDataCopy !== null &&
    lessorSocialSelected &&
    lessorDataCopy.name === 'Autre'
  "
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2 sm:pl-4 py-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "lessorInformations.lessorName" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [(ngModel)]="lessorDataName"
        [disabled]="
          !getIsEditable(
            policyFieldsVM,
            PolicyFields.OPTIONALSERVICE,
            OptionalService.LessorName,
            hasEndorsementWait4Sign
          )
        "
        pInputText
        type="text"
        [ngClass]="
          getInputClass(
            lessorDataNameHasChanged,
            getIsEditable(
              policyFieldsVM,
              PolicyFields.OPTIONALSERVICE,
              OptionalService.LessorName,
              hasEndorsementWait4Sign
            )
          ) + ' w-full'
        "
        [placeholder]="'lessorInformations.lessorNamePlaceholder' | translate"
        (ngModelChange)="onLessorDataNameChange()" />
    </div>
  </div>
</div>
<!-- Lessor Email -->
<div
  *ngIf="
    getIsVisible(policyFieldsVM, PolicyFields.OPTIONALSERVICE, OptionalService.LessorEmail) &&
    policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption &&
    !lessorSocialSelected &&
    this.lessorDataCopy !== null
  "
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2 sm:pl-4 py-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "lessorInformations.lessorEmail" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [(ngModel)]="lessorDataCopy.email"
        [disabled]="
          !getIsEditable(
            policyFieldsVM,
            PolicyFields.OPTIONALSERVICE,
            OptionalService.LessorEmail,
            hasEndorsementWait4Sign
          )
        "
        pInputText
        type="text"
        [ngClass]="
          getInputClass(
            lessorMailHasChanged,
            getIsEditable(
              policyFieldsVM,
              PolicyFields.OPTIONALSERVICE,
              OptionalService.LessorEmail,
              hasEndorsementWait4Sign
            )
          ) + ' w-full'
        "
        [placeholder]="'lessorInformations.lessorEmailPlaceholder' | translate"
        (ngModelChange)="onLessorMailChange()" />
    </div>
  </div>
</div>

<!-- Lessor House Occupied -->
<div
  *ngIf="
    getIsVisible(policyFieldsVM, PolicyFields.OPTIONALSERVICE, OptionalService.AlreadyInHousing) &&
    policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption &&
    lessorSocialSelected &&
    this.lessorDataCopy !== null
  "
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2 sm:pl-4 py-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "lessorInformations.houseIsOccupied" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="yesNoValues"
        [(ngModel)]="lessorDataCopy.houseIsOccuped"
        appendTo="body"
        [disabled]="
          !getIsEditable(
            policyFieldsVM,
            PolicyFields.OPTIONALSERVICE,
            OptionalService.AlreadyInHousing,
            hasEndorsementWait4Sign
          )
        "
        [styleClass]="
          getDropdownClass(
            houseIsOccupedHasChanged,
            getIsEditable(
              policyFieldsVM,
              PolicyFields.OPTIONALSERVICE,
              OptionalService.AlreadyInHousing,
              hasEndorsementWait4Sign
            )
          ) + ' w-full'
        "
        (ngModelChange)="onHouseOccupedChange()"></p-dropdown>
    </div>
  </div>
</div>

<!-- Référence client -->
<div
  *ngIf="
    getIsVisible(policyFieldsVM, PolicyFields.OPTIONALSERVICE, OptionalService.CustomerReference) &&
    policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption &&
    lessorSocialSelected &&
    this.lessorDataCopy !== null
  "
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2 sm:pl-4 py-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "lessorInformations.firstReference.RIVP" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [(ngModel)]="lessorDataCopy.ref1"
        [disabled]="
          !getIsEditable(
            policyFieldsVM,
            PolicyFields.OPTIONALSERVICE,
            OptionalService.CustomerReference,
            hasEndorsementWait4Sign
          )
        "
        pInputText
        type="text"
        [ngClass]="
          getInputClass(
            referenceClientHasChanged,
            getIsEditable(
              policyFieldsVM,
              PolicyFields.OPTIONALSERVICE,
              OptionalService.CustomerReference,
              hasEndorsementWait4Sign
            )
          ) + ' w-full'
        "
        [placeholder]="'lessorInformations.firstReference.RIVP' | translate"
        (ngModelChange)="onReferenceClientChange()" />
    </div>
  </div>
</div>

<!-- Numéro de local principal -->
<div
  *ngIf="
    getIsVisible(policyFieldsVM, PolicyFields.OPTIONALSERVICE, OptionalService.MainSiteNumber) &&
    policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption &&
    lessorSocialSelected &&
    this.lessorDataCopy !== null
  "
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2 sm:pl-4 py-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "lessorInformations.secondReference.RIVP" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [(ngModel)]="lessorDataCopy.ref2"
        [disabled]="
          !getIsEditable(
            policyFieldsVM,
            PolicyFields.OPTIONALSERVICE,
            OptionalService.MainSiteNumber,
            hasEndorsementWait4Sign
          )
        "
        pInputText
        type="text"
        [ngClass]="
          getInputClass(
            localPrincipalHasChanged,
            getIsEditable(
              policyFieldsVM,
              PolicyFields.OPTIONALSERVICE,
              OptionalService.MainSiteNumber,
              hasEndorsementWait4Sign
            )
          ) + ' w-full'
        "
        [placeholder]="'lessorInformations.secondReference.RIVP' | translate"
        (ngModelChange)="onLocalPrincipalChange()" />
    </div>
  </div>
</div>

<!-- Lessor MailSendDate -->
<div
  *ngIf="
    getIsVisible(policyFieldsVM, PolicyFields.OPTIONALSERVICE, OptionalService.LessorMailSentDate) &&
    policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption &&
    policyDetailsCopy.optionalServicePolicyVm.lastSendCertificate !== null &&
    this.lessorDataCopy !== null
  "
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2 sm:pl-4 py-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "lessorInformations.lessorDate" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [(ngModel)]="policyDetailsCopy.optionalServicePolicyVm.lastSendCertificate"
        [disabled]="
          !getIsEditable(
            policyFieldsVM,
            PolicyFields.OPTIONALSERVICE,
            OptionalService.LessorMailSentDate,
            hasEndorsementWait4Sign
          )
        "
        pInputText
        type="text"
        [ngClass]="
          getInputClass(
            lessorMailSendDateHasChanged,
            getIsEditable(
              policyFieldsVM,
              PolicyFields.OPTIONALSERVICE,
              OptionalService.LessorMailSentDate,
              hasEndorsementWait4Sign
            )
          ) + ' w-full'
        "
        [placeholder]="'housingSection.addressPlaceholder' | translate"
        (ngModelChange)="onLessorMailSendDateChange()" />
    </div>
  </div>
</div>

